module.exports = __webpack_public_path__ + "static/img/feature-bg-blue.7d03684.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature-bg-blue.png
// module id = Rdht
// module chunks = 0